import { render, staticRenderFns } from "./DishServicePolicyForm.vue?vue&type=template&id=8c1430d2&scoped=true"
import script from "./DishServicePolicyForm.vue?vue&type=script&lang=js"
export * from "./DishServicePolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1430d2",
  null
  
)

export default component.exports